import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lightbulb, Target } from 'lucide-react';
export function Slide4MarketResearch() {
  const perceptions = [{
    title: 'Scientific Expertise',
    stat: '54%',
    desc: 'rate Minerva 5/5 (the #1 partner priority)'
  }, {
    title: 'Isotope Supply',
    stat: '65%',
    desc: 'positive perception on solving this top bottleneck'
  }, {
    title: 'Supply Chain Reliability',
    stat: '67%',
    desc: 'rate 4-5/5 for future-critical needs'
  }, {
    title: 'Scientific Translation',
    stat: 'Strong',
    desc: 'market recognition of translational capabilities'
  }];
  return <div className="flex flex-col h-full max-w-[1700px] mx-auto w-full" data-id="element-613">
      <div className="mb-8 border-b border-slate-100 pb-6" data-id="element-614">
        <div className="text-sm font-bold text-snakker-purple uppercase tracking-widest mb-2" data-id="element-615">
          04 / Market Research
        </div>
        <h2 className="text-4xl font-display font-bold text-slate-900 mb-2" data-id="element-616">
          Invaluable Strategic Intelligence
        </h2>
        <p className="text-xl text-slate-500 max-w-4xl" data-id="element-617">
          Minerva received exceptional perception ratings across all critical
          decision factors.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 flex-1 items-stretch" data-id="element-618">
        {/* Perception Data */}
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2
      }} className="lg:col-span-8 grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-619">
          {perceptions.map((p, i) => <div key={i} className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm flex flex-col justify-center" data-id="element-620">
              <div className="flex items-center justify-between mb-2" data-id="element-621">
                <h3 className="text-lg font-bold text-slate-800" data-id="element-622">{p.title}</h3>
                <div className="bg-minerva-blue/10 text-minerva-blue font-bold px-2.5 py-1 rounded-full text-xs shrink-0" data-id="element-623">
                  {p.stat}
                </div>
              </div>
              <p className="text-slate-600 text-sm" data-id="element-624">{p.desc}</p>
            </div>)}
        </motion.div>

        {/* Strategic Intelligence Unlocked */}
        <motion.div initial={{
        opacity: 0,
        x: 20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.4
      }} className="lg:col-span-4 bg-slate-50 rounded-3xl p-6 border border-slate-200 flex flex-col" data-id="element-625">
          <div className="flex items-center gap-3 mb-4" data-id="element-626">
            <div className="p-2.5 bg-indigo-100 rounded-xl" data-id="element-627">
              <Lightbulb className="w-5 h-5 text-indigo-600" data-id="element-628" />
            </div>
            <h3 className="text-xl font-bold text-slate-800" data-id="element-629">
              Intelligence Unlocked
            </h3>
          </div>

          <div className="space-y-4 flex-1" data-id="element-630">
            <div data-id="element-631">
              <h4 className="font-bold text-slate-800 mb-2 flex items-center gap-2 text-sm" data-id="element-632">
                <Target className="w-4 h-4 text-indigo-500" data-id="element-633" /> Customer Needs
              </h4>
              <ul className="text-sm text-slate-600 space-y-1.5 pl-6 list-disc marker:text-indigo-300" data-id="element-634">
                <li data-id="element-635">#1 bottleneck: Isotope Supply</li>
                <li data-id="element-636">Key value: Scientific Expertise</li>
                <li data-id="element-637">Future priority: Supply Chain Reliability</li>
              </ul>
            </div>

            <div data-id="element-638">
              <h4 className="font-bold text-slate-800 mb-2 flex items-center gap-2 text-sm" data-id="element-639">
                <ShieldCheck className="w-4 h-4 text-indigo-500" data-id="element-640" /> Competitive
                Positioning
              </h4>
              <ul className="text-sm text-slate-600 space-y-1.5 pl-6 list-disc marker:text-indigo-300" data-id="element-641">
                <li data-id="element-642">Strongly positioned on ALL key factors</li>
                <li data-id="element-643">Data-backed narrative for sales</li>
              </ul>
            </div>
          </div>
        </motion.div>
      </div>
    </div>;
}